import script from "./InstruccionesSinMartillero.vue?vue&type=script&setup=true&lang=js"
export * from "./InstruccionesSinMartillero.vue?vue&type=script&setup=true&lang=js"

import "./InstruccionesSinMartillero.vue?vue&type=style&index=0&id=8b87e620&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b87e620"]])

export default __exports__